








import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import ProgramPage from "@/shared/components/programs/ProgramPage.vue";
import CourseCard from "@/shared/components/courses/CourseCard.vue";
import { CourseList } from "@/shared/components/courses/courseList";

@Component({ components: { ProgramPage, CourseCard } })
export default class CoursesPage extends Vue {
  loading: boolean = true;
  courses: any[] = [];

  get emptyText(): string {
    if (this.loading) return this.$t("Loading").toString() + "...";
    return this.courses.length === 0 ? this.$t("No courses available").toString() : "";
  }

  async mounted() {
    this.courses = await CourseList.load();
    this.loading = false;
  }
}
